export default {
  getCurrentVerificationStep(state) {
    return state.currentVerificationStep;
  },
  getCurrentVerificationMethod(state) {
    return state.currentVerificationMethod;
  },
  getActiveIcon(state) {
    return state.activeIcon;
  },
  getAllowedVerificationMethods(state) {
    return state.allowedVerificationMethods;
  },
  getStartedAt(state) {
    return state.startedAt;
  },
  getBackendAuthorizationStatus(state) {
    return state.backendAuthorizationStatus;
  },
};
